/* eslint-disable react-native/no-inline-styles */
import React, { memo, useCallback, useState, useEffect } from 'react'

import { useContextValue } from '@batical/reducer/src'
import { CalculCodeStateKeys } from '@batical/types/src'
import { Select, MenuItem, FormControl } from '@mui/material'

import { CalculText, ViewColumnLine } from './LineStyleComponent'

export type PickerDoubleLineProps = {
  calculCode: CalculCodeStateKeys
  dataPicker: Array<{ label: string; value: string; children: Array<{ label: string; value: string }> }>
  subtitle?: string
  variableName: string
  disabled?: boolean
  onChange?: (uuid: string) => void
  doCalcul?: boolean
  first?: boolean
  last?: boolean
}
const PickerDoubleLine = ({
  onChange,
  calculCode,
  dataPicker,
  subtitle,
  variableName,
  doCalcul = false,
  first = false,
  last = false
}: PickerDoubleLineProps) => {
  const [value, update] = useContextValue(variableName, calculCode, doCalcul)

  const [picker1, setPicker1] = useState('')
  const [dataPicker2, setDataPicker2] = useState<Array<{ label: string; value: string }>>([])
  // const [textLabel, setTextLabel] = useState<string>(i18n.t('select_item'))
  useEffect(() => {
    if (dataPicker && dataPicker.length > 0) {
      for (let index = 0; index < dataPicker.length; index += 1) {
        const item = dataPicker[index]
        for (let sub = 0; sub < item.children.length; sub += 1) {
          const subItem = item.children[sub]

          if (subItem.value === value) {
            setDataPicker2(item.children)
            setPicker1(item.value)
            //  setTextLabel(`${item.value} - ${subItem.label}`)
            break
          }
        }
      }
    }
  }, [dataPicker, value])
  // useEffect(() => {
  //   if (dataPicker && dataPicker.length > 0) {
  //     for (let index = 0; index < dataPicker.length; index += 1) {
  //       const item = dataPicker[index]
  //       for (let sub = 0; sub < item.children.length; sub += 1) {
  //         const subItem = item.children[sub]

  //         if (subItem.value === value) {
  //           setDataPicker2(item.children)
  //           setPicker1(item.value)
  //           setTextLabel(`${item.value} - ${subItem.label}`)
  //           break
  //         }
  //       }
  //     }
  //   }
  // }, [dataPicker, value])

  const _onChangePicker1 = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event: any) => {
      if (dataPicker && dataPicker.length > 0) {
        for (let index = 0; index < dataPicker.length; index += 1) {
          const item = dataPicker[index]
          if (item.value === event.target.value) {
            if (onChange) {
              onChange(item.children[0].value)
            } else {
              update(item.children[0].value)
            }
            break
          }
        }
      }
    },
    [dataPicker, onChange, update]
  )

  const _onChangePicker2 = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event: any) => {
      if (onChange) {
        onChange(String(event.target.value as string))
      } else {
        update(String(event.target.value as string))
      }
    },
    [onChange, update]
  )

  return (
    <ViewColumnLine first={first} last={last}>
      <div style={{ display: 'flex', width: '100%' }}>
        <FormControl sx={{ m: 1 }} fullWidth size="small">
          <Select labelId="demo-simple-select-label" id="demo-simple-select" value={picker1} onChange={_onChangePicker1} fullWidth>
            {dataPicker.map((item, index) => {
              return (
                <MenuItem value={item.value} key={`pickerLine_${calculCode}_${variableName}_${index}`}>
                  {item.label}
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1 }} fullWidth size="small">
          <Select labelId="demo-simple-select-label" id="demo-simple-select" value={value} onChange={_onChangePicker2} fullWidth>
            {dataPicker2.map((item, index) => {
              return (
                <MenuItem value={item.value} key={`pickerLine_${calculCode}_${variableName}_${index}`}>
                  {item.label}
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </div>
      <CalculText>{subtitle}</CalculText>
    </ViewColumnLine>
  )
}

export default memo(PickerDoubleLine)
